import { Injectable } from '@angular/core';
import { ApiService } from '../API/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UOTService {

  constructor(public apiService: ApiService) { }

  getUOT(): Observable<any> {
    return this.apiService.get('unittype/getunittypes')
  }

  addUOT(body : any): Observable<any> {
    return this.apiService.post('', body)
  }
  getProductTypes(body : any): Observable<any> {
    return this.apiService.post('producttype/getproducttypes', body)
  }
  addproductType(body : any): Observable<any> {
    return this.apiService.post('producttype/createproducttypes', body)
  }
  editproductType(body : any): Observable<any> {
    return this.apiService.post('producttype/editproducttypes', body)
  }

}
